module.exports = __webpack_public_path__ + "img/march_rules-ar.d149ca38.png";